import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import FormLabel from 'components/form_factory/form_label';
import FormError from 'components/form_factory/form_error';
import { observable } from 'mobx';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  margin: ${props => props.margin};
`;

@observer
class FormTextarea extends React.Component {
  @observable focused = false;
  @observable clicked = false;

  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    store: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    defaultValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
    type: PropTypes.string,
  };

  static defaultProps = {
    disabled: false,
    defaultValue: '',
    type: 'text',
  };

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.props.form.registerComponent(this.props);
  }

  componentWillUnmount() {
    // this.props.form.unregisterComponent(this.props);
  }

  onChange = () => {
    this.props.onChange(this.props.name, this.inputRef.current.value);
  }

  onFocus = () => {
    this.focused = true;
    this.clicked = true;
  }

  getValue() {
    return this.props.store.formCache[this.props.name] || '';
  }

  getError() {
    return this.props.store.getError(this.props.name);
  }

  name() {
    if (this.props.name.includes('.')) {
      const ary = this.props.name.split('.');
      return `${ary[0]}[${ary[1]}]`;
    }
    return this.props.name;
  }

  render() {
    return (
      <Wrapper
        margin={this.props.margin}
      >
        {
          this.props.type !== 'hidden' &&
            <FormLabel
              {...this.props}
            />
        }
        <textarea
          key={`input-${this.props.name}`}
          ref={this.inputRef}
          name={this.name()}
          type={this.props.type}
          onChange={this.onChange}
          value={this.getValue()}
          onFocus={this.onFocus}
          onBlur={() => this.focused = false}
        />
        {
          this.props.type !== 'hidden' &&
            <FormError
              message={this.getError()}
            />
        }
      </Wrapper>
    );
  }
}

export default FormTextarea;
